/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { GenerateImageResponse, GenerateImageVars } from '../openapi-types.gen.js';

export type { GenerateImageResponse, GenerateImageVars } from '../openapi-types.gen.js';

export const useGenerateImage = createMutationHook<GenerateImageVars, GenerateImageResponse, unknown>({
  specName: 'useGenerateImage',
  path: '/v1/images/generate',
  method: 'POST',
  resolveUrl: (vars: GenerateImageVars) => `/v1/images/generate`,
  buildBody: (vars: GenerateImageVars) => ({ mode: vars.mode, marketTitle: vars.marketTitle, outcomeLabel: vars.outcomeLabel, userPrompt: vars.userPrompt, category: vars.category, description: vars.description, sourceImageUrl: vars.sourceImageUrl, seed: vars.seed }),
  parseResponse: (raw: unknown): GenerateImageResponse => raw as GenerateImageResponse,
  optimistic: [{
    queryKey: ['images', 'detail'],
    apply: (prev: any, vars: GenerateImageVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = { ...next, used: String((Number((next as any).used) || 0) + Number(("1" /* literal */))) };
      next = { ...next, remaining: String((Number((next as any).remaining) || 0) + Number(("-1" /* literal */))) };
      return next;
    },
  }],
  
  
});
